import SignInForm from "../../SignIn";

const StudentPortal = () => {


    return (
        <div>
            <SignInForm />
        </div>
    );
}

export default StudentPortal;